import {Injectable} from '@angular/core';
import {Cliente} from "../../../models/cliente.model";
import {Operador} from "../../../models/operador.model";

@Injectable({
    providedIn: 'root'
})

export class StorageOperadorRepository {

    constructor() {
    }

    /**
     * Datos de sesión
     */


    public obtenerToken() {
        return localStorage.getItem('token');
    }

    public guardarToken(token: string) {
        localStorage.setItem('token', token);
    }

    public eliminarToken() {
        localStorage.removeItem('token');
    }

    public obtenerSesion(): Operador {
        return Operador.build(JSON.parse(<string>localStorage.getItem('currentUser')));
    }

    public guardarSesion(operadorObj: any) {
        localStorage.setItem('currentUser', JSON.stringify(operadorObj));
    }

    public eliminarSesion() {
        localStorage.removeItem('currentUser');
    }

    public cerrarSesion() {
        // @ts-ignore
        this.eliminarSesion();
        // @ts-ignore
        this.eliminarToken();
    }
}
